module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isReady) ? _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex flex-row justify-content-between"
  }, [_c('h2', {
    staticClass: "p-3 d-flex align-items-center"
  }, [_vm._v(_vm._s(_vm.isEdit ? 'Edit Rule Group' : 'New Rules Group'))]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center my-4 px-4"
  }, [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("Cancel\n                ")]), _vm._v(" "), _c('input', {
    staticClass: "btn wider mr-3",
    attrs: {
      "type": "submit",
      "value": "Save",
      "disabled": _vm.finalRuleGroupValidations
    },
    on: {
      "click": _vm.btnSave
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "new-product"
  }, [_c('div', {
    staticClass: "my-4"
  }, [_c('div', {
    staticClass: "px-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel mt-0 shaded radius-top-left-none radius-top-right-none"
  }, [_c('h5', [_vm._v("Group Details:")]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3 row-min-height"
  }, [_c('div', {
    staticClass: "col-xl-4 col-lg-4 col-md-6 mb-3 mr-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pl-0 col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rulesGroup.name),
      expression: "rulesGroup.name"
    }],
    staticClass: "col-12 btn-height",
    attrs: {
      "type": "text",
      "placeholder": "Example Group Name"
    },
    domProps: {
      "value": (_vm.rulesGroup.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rulesGroup, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.rulesGroup.name.$invalid) ? _c('div', {
    staticClass: "messages error"
  }, [(!_vm.$v.rulesGroup.name.required) ? _c('span', [_vm._v("Name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.rulesGroup.name.minLength) ? _c('span', [_vm._v("Name must have at least 5 characters.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.rulesGroup.name.validCharacters) ? _c('span', [_vm._v("\n                                                Invalid characters. Please use only letters, numbers, spaces, and the following special characters: "), _c('strong', [_vm._v(_vm._s(_vm.specialCharacters))])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-lg-4 col-md-5 mb-5 booking-window-alignment mr-5"
  }, [_c('span', {
    staticClass: "fs-small bold mr-2 text-nowrap"
  }, [_vm._v("Booking Window")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "labels": {
        checked: 'Yes',
        unchecked: 'No'
      }
    },
    on: {
      "change": function($event) {
        return _vm.toggleShowInactive($event)
      }
    },
    model: {
      value: (_vm.rulesGroup.isBookingWindowActive),
      callback: function($$v) {
        _vm.$set(_vm.rulesGroup, "isBookingWindowActive", $$v)
      },
      expression: "rulesGroup.isBookingWindowActive"
    }
  })], 1), _vm._v(" "), (_vm.rulesGroup.isBookingWindowActive) ? _c('div', {
    staticClass: "d-flex col-xl-4 col-lg-5 col-md-6 mb-3"
  }, [_c('div', {
    staticClass: "col-7 col-md-8 pl-0"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "d-flex col-6 pl-0"
  }, [_c('v-select', {
    staticClass: "select-width",
    attrs: {
      "label": "val",
      "value": _vm.bwFromInit,
      "options": _vm.bwFromOptions
    },
    on: {
      "input": function($event) {
        return _vm.bwUpdateVal($event, 'From')
      }
    }
  }), _vm._v(" "), (_vm.rulesGroup.bookingWindowFromType === 2) ? _c('div', {
    staticClass: "ml-2 time-picker-witdth"
  }, [_c('timepicker', {
    staticClass: "btn-height",
    attrs: {
      "defaultTime": _vm.timerValue(_vm.rulesGroup.bookingWindowFrom),
      "disabled": false
    },
    on: {
      "change": function($event) {
        _vm.rulesGroup.bookingWindowFrom = $event + ":00"
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.rulesGroup.bookingWindowFromType === 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rulesGroup.bookingWindowFrom),
      expression: "rulesGroup.bookingWindowFrom"
    }],
    staticClass: "col-8 btn-height ml-2",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.rulesGroup.bookingWindowFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rulesGroup, "bookingWindowFrom", $event.target.value)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.bwFromValidation) ? _c('div', {
    staticClass: "messages error"
  }, [_c('span', [_vm._v("From is required.")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "d-flex col-7 col-md-8 pl-0"
  }, [_c('v-select', {
    staticClass: "select-width",
    attrs: {
      "label": "val",
      "value": _vm.bwToInit,
      "options": _vm.bwUntilOptions
    },
    on: {
      "input": function($event) {
        return _vm.bwUpdateVal($event, 'To')
      }
    }
  }), _vm._v(" "), (_vm.rulesGroup.bookingWindowToType === 2) ? _c('div', {
    staticClass: "ml-2 time-picker-witdth"
  }, [_c('timepicker', {
    staticClass: "btn-height",
    attrs: {
      "defaultTime": _vm.timerValue(_vm.rulesGroup.bookingWindowTo),
      "disabled": false
    },
    on: {
      "change": function($event) {
        _vm.rulesGroup.bookingWindowTo = $event + ":00"
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.rulesGroup.bookingWindowToType === 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rulesGroup.bookingWindowTo),
      expression: "rulesGroup.bookingWindowTo"
    }],
    staticClass: "col-8 btn-height ml-2",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.rulesGroup.bookingWindowTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rulesGroup, "bookingWindowTo", $event.target.value)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.bwToValidation) ? _c('div', {
    staticClass: "messages error"
  }, [_c('span', [_vm._v("Until is required.")])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm.rulesGroup.isBookingWindowActive) ? _c('div', {
    staticClass: "row mt-1 mb-2 row-min-height"
  }, [_c('div', {
    staticClass: "col-lg-2 col-md-4 mb-3"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!(_vm.rulesGroup.bookingWindowFromType === 0 && _vm.rulesGroup.bookingWindowToType === 0)) ? _c('div', [_c('label', {
    staticClass: "mb-0"
  }, [_vm._v("Occupation"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex col-9 pl-0"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.rulesGroup.occupancy),
      expression: "rulesGroup.occupancy",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "glued-right btn-height col-6",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.rulesGroup.occupancy)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rulesGroup, "occupancy", _vm._n($event.target.value))
      }, function($event) {
        return _vm.limitInput()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left"
  }, [_vm._v("%")]), _vm._v(" "), _c('v-select', {
    staticClass: "ml-2 select-width",
    attrs: {
      "autocomplete": "no",
      "label": "val",
      "options": _vm.operatorOptions,
      "value": _vm.operatorTypeInit
    },
    on: {
      "input": function($event) {
        return _vm.updateOperatorInfo($event)
      }
    }
  })], 1)]), _vm._v(" "), (_vm.$v.rulesGroup.occupancy.$invalid || _vm.$v.rulesGroup.occupancyType.$invalid) ? _c('div', {
    staticClass: "messages error"
  }, [_c('span', [_vm._v("Occupation is required.")])]) : _vm._e()]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v("Rules:")]), _vm._v(" "), _c('div', {
    staticClass: "row mb-5"
  }, [(_vm.rulesLength > 0) ? _c('div', {
    staticClass: "col-sm-12 table-min-height"
  }, [_c('table', {
    staticClass: "w-100 table narrow"
  }, [_vm._m(3), _vm._v(" "), _c('draggable', {
    staticClass: "w-100",
    attrs: {
      "v-bind": _vm.draggableOptions,
      "tag": 'tbody'
    },
    on: {
      "change": function($event) {
        return _vm.updateOrder()
      }
    },
    model: {
      value: (_vm.rulesGroup.priceRules),
      callback: function($$v) {
        _vm.$set(_vm.rulesGroup, "priceRules", $$v)
      },
      expression: "rulesGroup.priceRules"
    }
  }, _vm._l((_vm.rulesGroup.priceRules), function(rule, index) {
    return (!rule.isDeleted) ? _c('tr', {
      staticClass: "stopRow w-100 tr-size",
      class: {
        'repetead-types-warning': rule.isRepeatedType
      }
    }, [_c('td', {
      staticClass: "overflowHidden"
    }, [_c('div', {
      staticClass: "routeMarker radius-circle"
    }, [_c('span', {
      staticClass: "fs-smaller radius-circle"
    }, [_vm._v(_vm._s(rule.executionOrder))])])]), _vm._v(" "), _c('td', {}, [_c('v-select', {
      staticClass: "w-100 d-inline-block align-middle",
      attrs: {
        "options": _vm.existingRules,
        "disabled": rule.isInGroup,
        "label": "name",
        "value": rule.name
      },
      on: {
        "input": function($event) {
          return _vm.updateRuleInfo(index, $event)
        }
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "w-100"
    }, [_vm._v(_vm._s(rule.ruleDetails))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center pr-2"
    }, [_c('i', {
      staticClass: "ico ico-delete m-1 fs-large pointer dark",
      style: ({
        visibility: _vm.rulesGroup.priceRules.filter(function (item) { return !item.isDeleted; }).length === 1 ? 'hidden' : 'visible'
      }),
      on: {
        "click": function($event) {
          return _vm.removeRule(rule, index)
        }
      }
    })])]) : _vm._e()
  }), 0)], 1), _vm._v(" "), (_vm.hasRepeatedRules) ? _c('div', {
    staticClass: "messages error mt-3"
  }, [_c('span', [_vm._v("You can't have 2 or more rules of the same type in the group. Please remove one of the repeated rules!")])]) : _vm._e(), _vm._v(" "), (_vm.existingRules.length > 0) ? _c('div', {
    staticClass: "col-sm-4 mt-4"
  }, [_c('div', {
    staticClass: "add d-flex align-items-center pointer fs-small bold btn-add",
    on: {
      "click": _vm.addRule
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add new\n                                            ")])]) : _vm._e()]) : _c('div', {
    staticClass: "text-center dark col-sm-12 my-4"
  }, [_vm._m(4), _vm._v(" "), _c('button', {
    staticClass: "btn mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createRule
    }
  }, [_vm._v("Create Rule")])])]), _vm._v(" "), _c('h5', [_vm._v("Notifications:")]), _vm._v(" "), _c('div', {
    staticClass: "panel shaded col-sm-6 notification-min-heigth pl-0 border-0 pt-3"
  }, [_c('div', {
    staticClass: "d-flex pb-1 mb-3"
  }, [_c('label', {
    staticClass: "fs-normal darkest mr-5"
  }, [_vm._v("Rule notification")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "labels": {
        checked: 'Yes',
        unchecked: 'No'
      }
    },
    on: {
      "change": function($event) {
        return _vm.toggleNotification($event)
      }
    },
    model: {
      value: (_vm.rulesGroup.sendNotificationWhenRuleApplied),
      callback: function($$v) {
        _vm.$set(_vm.rulesGroup, "sendNotificationWhenRuleApplied", $$v)
      },
      expression: "rulesGroup.sendNotificationWhenRuleApplied"
    }
  })], 1), _vm._v(" "), (_vm.rulesGroup.sendNotificationWhenRuleApplied) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rulesGroup.email),
      expression: "rulesGroup.email"
    }],
    staticClass: "mt-1 col-12",
    attrs: {
      "type": "text",
      "placeholder": "email1@domain.com, email2@domain.com, email3@domain.com"
    },
    domProps: {
      "value": (_vm.rulesGroup.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rulesGroup, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.rulesGroup.email.$invalid) ? _c('div', {
    staticClass: "messages error ml-3"
  }, [_c('span', [_vm._v("When notifications are active email is required.")])]) : _vm._e()]) : _vm._e()])])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mb-0"
  }, [_vm._v("Name"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mb-0"
  }, [_vm._v("From"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mb-0"
  }, [_vm._v("Until"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "thead-size"
  }, [_c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "60px"
    }
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Order")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "30%"
    }
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "auto"
    }
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Details")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "25px"
    }
  }, [_vm._v(" ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fs-large fa fa-file-contract color-6"
  }), _vm._v("You have no Rules Groups, let's create one.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mb-1 darkest"
  }, [_vm._v("Email "), _c('span', {
    staticClass: "normal fs-smaller dark ml-2"
  }, [_vm._v("(You can enter multiple emails by separating them with comma \",\")")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4def6cb7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4def6cb7"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/revenue/rules/NewRulesGroup.vue
// module id = 3101
// module chunks = 0